import type { BackgroundType, UsageType, ContentRating } from "@shared/commission";

export type { BackgroundType, UsageType, ContentRating };
export type StepId = "type" | "scene" | "characters" | "contact" | "review";
export const STEP_IDS: readonly StepId[] = ["type", "scene", "characters", "contact", "review"];
export type PostingPermission = "yes" | "delayed" | "no";

export type BlockKey = "look" | "action" | "extra";
export const BLOCK_KEYS: readonly BlockKey[] = ["look", "action", "extra"];
export interface BlockDraft { text: string; refs: string[] }
export interface CharacterDraft { id: string; name: string; type: string | null; look: BlockDraft; action: BlockDraft; extra: BlockDraft }

export interface Sample { imageId: string; url: string }
export interface ArtistSamples { types: Record<string, Sample>; backgrounds: Partial<Record<BackgroundType, Sample>> }

/** Mirrors PublicIntakeArtist from netlify/functions/lib/intake/commissionArtistHandler.ts */
export interface IntakeArtist {
  id: string; slug: string; name: string; status: "open" | "waitlist" | "closed";
  prices: Record<string, string | number>; additionalFees: Record<string, string>; visibleFees: string[];
  nsfwLevel: "safe" | "suggestive" | "nsfw"; profilePicture: string | null; coverImage: string | null;
  deliveryDays: number | null; tosMarkdown: string | null; artistTosHash: string | null; studioTosHash: string;
  samples: ArtistSamples;
}

export interface IntakeDraft {
  artistSlug: string | null; step: StepId; direction: 1 | -1;
  sameType: boolean; characterCount: number; characters: CharacterDraft[];
  backgroundType: BackgroundType; sceneDescription: string; sceneRefs: string[];
  usageType: UsageType | null; contentRating: ContentRating | null;
  deadlineMode: "none" | "date"; deadline: string | null; manualFees: string[]; notes: string;
  postingPermission: PostingPermission | null;
  clientName: string; clientEmail: string; clientDiscord: string;
  tosAccepted: boolean; dismissedNudges: string[];
}
